import { connect } from 'react-redux';
import filter from 'lodash/filter';

import FeaturedListingCollection from './FeaturedListingCollection';

import type { RootReduxState } from '../../flux/reducers';
import type { ListingDetails } from '@/srcLegacy/types/listingDetails.type';

interface MostPopularListingsProps {
  mostPopularListings: Array<ListingDetails>;
  areaName: string;
  onListingClick: () => void;
  screenWidthForDesktopSRPFilter: 'sm' | 'md' | 'lg' | 'xl';
}

const MostPopularListings = ({
  mostPopularListings,
  areaName,
  onListingClick,
  screenWidthForDesktopSRPFilter,
}: MostPopularListingsProps) => {
  if (mostPopularListings.length === 0) {
    return null;
  }

  const header = areaName ? `Most popular rentals in ${areaName}` : 'Most popular rentals';

  return (
    <FeaturedListingCollection
      header={header}
      listings={mostPopularListings}
      onListingClick={onListingClick}
      screenWidthForDesktopSRPFilter={screenWidthForDesktopSRPFilter}
      propertyCardTriggerLocation="most_popular_rentals_nearby_module"
      triggerLocation={'home_details'}
      triggerObject={'home_details_component|most_popular'}
    />
  );
};

const mapStateToProps = (state: RootReduxState) => {
  return {
    mostPopularListings: filter(state.listings.listingGroups.mostPopular, (listing) => {
      // Filter out the current listing
      if (
        state.location.current.pathname === listing.uriMalone ||
        state.location.current.pathname === listing.uriBuilding ||
        state.location.current.pathname === listing.uriV2
      ) {
        return false;
      }
      return true;
    }),
    areaName: state.area.area?.name || '',
  };
};

export default connect(mapStateToProps)(MostPopularListings);
